import { call, put } from 'redux-saga/effects';
import { generateTakeLatestSaga } from 'utils/sagas';

import {
	GET_HOMEPAGE
} from './constants';

import {
	getHomepageSuccess,
	getHomepageError
} from './actions';

import { setErrorMessage } from 'pages/App/actions';

// HTTP request helpers
import request from 'utils/request';

export function* getHomepage({ data: { homepageSlug } }) {
	let requestURL = '/api/v1/cms/homepage';
	if (homepageSlug) {
		requestURL = `/api/v1/cms/entries?url_title=${homepageSlug}&channel=homepage_2020`;
	}

	try {
		const data = yield call(request, requestURL, {
			params: {
				serializer: 'array'
			}
		});
		yield put(getHomepageSuccess(data.data, !!homepageSlug));
	} catch (err) {
		yield put(getHomepageError(err));
		yield put(setErrorMessage());
	}
}

// Root saga watchers
export const getHomepageSaga = generateTakeLatestSaga(GET_HOMEPAGE, getHomepage);

// Bootstrap sagas
export default [
	getHomepageSaga
];
